import "@goodbye/design-tokens/tokens.css";
import { createFirebase } from "@goodbye/firebase";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./App";
import { env } from "./env";
import { startSW } from "./registerSW";
import { initSentry } from "./sentry";

initSentry();

createFirebase({
  config: env.firebase,
  useEmulators: env.useEmulators,
});

startSW();

const container = document.getElementById("root");
if (!container) throw new Error("Missing #root element");

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
